import { memo } from "react"
import type { FC } from "react"

const CopyIconComponent: FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.53842 13.721L4.56685 13.721C3.42632 13.721 2.5 12.7947 2.5 11.6541L2.5 7.68256C2.5 6.54204 3.42632 5.61572 4.56685 5.61572L8.53842 5.61572C9.67894 5.61572 10.6053 6.54204 10.6053 7.68256L10.6053 11.6541C10.6053 12.7947 9.67894 13.721 8.53842 13.721ZM4.56685 6.77362C4.06316 6.77362 3.65789 7.18467 3.65789 7.68256L3.65789 11.6541C3.65789 12.1578 4.06895 12.5631 4.56685 12.5631H8.53842C9.0421 12.5631 9.44737 12.152 9.44737 11.6541V7.68256C9.44737 7.17888 9.03631 6.77362 8.53842 6.77362L4.56685 6.77362Z"
        fill="currentColor"
      />
      <path
        d="M11.9139 10.8262C11.6766 10.8262 11.4508 10.6757 11.3697 10.4441C11.2597 10.1431 11.4218 9.81305 11.7229 9.70305C12.0934 9.56989 12.3424 9.21674 12.3424 8.82884V4.80516C12.3424 4.29568 11.9255 3.87884 11.4161 3.87884L7.39815 3.87884C7.00447 3.87884 6.6571 4.12779 6.52394 4.49832C6.41394 4.79937 6.08392 4.95568 5.78287 4.85147C5.48182 4.74147 5.32551 4.41147 5.42972 4.11042C5.72498 3.28253 6.51815 2.72095 7.39815 2.72095L11.4161 2.72095C12.5682 2.72095 13.5002 3.65884 13.5002 4.80516L13.5002 8.82305C13.5002 9.70305 12.9444 10.4904 12.1108 10.7915C12.0471 10.8146 11.9834 10.8262 11.9139 10.8262Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CopyIcon = memo(CopyIconComponent)
